import { render, staticRenderFns } from "./AppRatingInput.vue?vue&type=template&id=3ed5cb7d&scoped=true"
import script from "./AppRatingInput.vue?vue&type=script&lang=js"
export * from "./AppRatingInput.vue?vue&type=script&lang=js"
import style0 from "./AppRatingInput.vue?vue&type=style&index=0&id=3ed5cb7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed5cb7d",
  null
  
)

export default component.exports